import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getLiteraryDesignUnitVisual } from "../../data/visuals";

import styles from "./viz-ephesians-literary-design-unit.css";

import type { LiteraryDesignUnitVisualData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-viz-ephesians-literary-design-unit")
export class EphesiansLiteraryDesignUnit extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: LiteraryDesignUnitVisualData;

  @property({ attribute: "debug" })
  debug?: boolean;

  render() {
    if (!this.data) return;

    const { usx, html: designHTML, caption } = this.data;

    if (usx?.length) {
      return html`
        <bp-literary-design usx="${usx}">
          ${caption &&
          html`
            <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption>
          `}
        </bp-literary-design>
      `;
    } else {
      return html`
        <div class="container">
          ${this.debug
            ? html`<bp-ephesians-literary-design debug .data=${designHTML} />`
            : html`<bp-ephesians-literary-design .data=${designHTML} />`}
        </div>
        ${caption &&
        html` <bp-caption slot="caption">${unsafeHTML(caption)}</bp-caption> `}
      `;
    }
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getLiteraryDesignUnitVisual(this.arcId)
      .then(({ data }) => {
        console.log("data", data);
        this.data = { ...data };

        if (data.usx) {
          const parser = new DOMParser();
          const usx = parser.parseFromString(`${data.usx}`, "text/xml");
          this.data = { ...data, usx: usx.documentElement.outerHTML };
        }
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-ephesians-literary-design-unit": EphesiansLiteraryDesignUnit;
  }
}
